import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FiRefreshCw } from 'react-icons/fi'
import { Trans, useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { MenuLinkItem } from '../../../components/Template/Header'
import {
  getLastSyncDate,
  isSyncing,
} from '../../../reducers/synchronize/selectors/lastSync'
import SpinningIcon from '../../../components/Template/SpinningIcon'
import HintPopper from '../../../components/Calendar/BookingCalendar/EventHint/HintPopper'
import Button from '../../../components/Template/Button'
import { useFormatTime } from '../../../hooks/useFormatTime'
import { theme } from '../../../theme'
import { SynchronizeActions } from '../../../reducers/synchronize/actionNames'
import { is } from '../../../components/MediaQuery'

function Synchronization({ size }) {
  const isSynchronizing = useSelector(isSyncing)
  const dispatch = useDispatch()
  const anchorRef = useRef()
  const [open, setOpen] = useState(false)
  const [timeout, setTimeOut] = useState(null)
  const lastSync = useSelector(getLastSyncDate)
  const formatTime = useFormatTime()
  const { t } = useTranslation()

  const isDesktop = is.desktop()

  function runSync() {
    if (!isSynchronizing) {
      dispatch({ type: SynchronizeActions.RequestSync })
    }
  }

  function openHint() {
    setTimeOut(setTimeout(() => setOpen(true), 200))
  }

  function closeHint() {
    clearTimeout(timeout)
    setOpen(false)
  }

  return (
    <>
      <MenuLinkItem
        size={size}
        center={true}
        style={{ padding: `0 ${0.6 * size}em` }}
        onClick={runSync}
        onMouseEnter={openHint}
        onMouseLeave={closeHint}
        ref={anchorRef}
        data-cy={'header-sync-button'}
      >
        {isSynchronizing ? (
          <SpinningIcon size={21 * size} />
        ) : (
          <FiRefreshCw size={21 * size} />
        )}
      </MenuLinkItem>
      <HintPopper
        zIndex={4000}
        placement={'bottom'}
        size={size}
        open={isDesktop && open}
        anchorEl={anchorRef.current}
      >
        <>
          <Flex
            alignCenter={true}
            justifyCenter={true}
            full={true}
            style={{
              color: theme.colors.palette.warmGrey,
              fontSize: '14px',
              padding: '15px',
              textAlign: 'center',
            }}
          >
            {t('BBO_2070_automatic_sync')}
          </Flex>
          <Button
            size={size}
            primary={true}
            style={{ cursor: 'unset', height: `${60 * size}px` }}
          >
            <Flex justifyBetween={true} full={true} alignCenter={true}>
              <Trans i18nKey={'pref_last_sync'} />
              <div>{formatTime(new Date(lastSync))}</div>
            </Flex>
          </Button>
        </>
      </HintPopper>
    </>
  )
}

export default Synchronization
